// 변경계약서 고객 링크 액션(rpc) — input.token 은 주소의 토큰과 같아야 한다(서버가 맞춰 본다).
import { shareRpc } from "@/api/client";

export const acceptChangeOrderByLink = (input: { token: string; id: string; name: string; agree: boolean; doc_hash?: string | null; signature?: string | null }) =>
  shareRpc("c", input.token, "acceptChangeOrderByLink", input);

export const rejectChangeOrderByLink = (input: { token: string; id: string; name: string; reason: string }) =>
  shareRpc("c", input.token, "rejectChangeOrderByLink", input);
